/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */


(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                $('.nav .has-mega').on('click', 'a', function(e){
                    e.preventDefault();
                    var menu = $(this).parent('li').attr('id');
                    var offset = $(this).offset().left;
                    var menu_obj = $('.mega-menu[data-mega-menu="'+menu+'"]');

                    // get offset if not full width nav
                    if( menu_obj.hasClass('mega-menu--auto-width') ) {
                        menu_obj.css('left', offset);
                    }

                    // open nav item if not current active, just close it
                    if( menu_obj.hasClass('mega-menu--open') ) {
                        menu_obj.removeClass('mega-menu--open');
                    } else {
                        $('.mega-menu--open').removeClass('mega-menu--open');
                        menu_obj.addClass('mega-menu--open');
                    }

                    // mobile class for 'back to main menu' toggle
                    if( $('.nav-primary').hasClass('nav-primary--mobile') ) {
                        $('.nav-mobile__back').addClass('nav-mobile__back--open');
                    }
                });

                $('.nav-mobile__back').on('click', function(){
                    $('.mega-menu--open').removeClass('mega-menu--open');
                    $(this).removeClass('nav-mobile__back--open');
                });


                $('.nav-mobile__toggle').on('click', function(e){
                    e.preventDefault();
                    $('.nav-primary').toggleClass('nav-primary--open');
                    // add mobile class for use with mega click listener above
                    $('.nav-primary').addClass('nav-primary--mobile');
                });

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
                $('a[data-mfp-src^="#"]').on('click', function(e){
                    e.preventDefault();
                    var $this = $(this);
                    var src = $this.attr('data-mfp-src');

                    $.magnificPopup.open({
                        items: {
                            src: $(src)
                        },
                        type: 'inline'
                    });
                });
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        },
        // About us page, note the change from about-us to about_us.
        'faq': {
          init: function() {
            // JavaScript to be fired on the about us page
            $('#faqFilter').on('change',function(){
              //alert($(this).val());
              var url = location.protocol + '//' + location.host + location.pathname;//window.location.href;
              if (url.indexOf('?') > -1){
                url += '&subject='+$(this).val();
              }else{
                url += '?subject='+$(this).val();
              }
              window.location.href = url;
            }); 
          }
        }
    }
    
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    $(window).load(function(){
        /* Build new ShopifyBuy client
        ============================================================ */
        var client = ShopifyBuy.buildClient({
            accessToken: '1527c8e0733963b39c073decdc412e9d',
            domain: 'johnstonseedco.myshopify.com',
            appId: '6'
        });

        var product;
        var cart;
        var cartLineItemCount;
        var productId = jsc_vars.shopify_id;

        console.log(jsc_vars.shopify_id);

        if(localStorage.getItem('lastCartId')) {
            client.fetchCart(localStorage.getItem('lastCartId')).then(function(remoteCart) {
                cart = remoteCart;
                cartLineItemCount = cart.lineItems.length;
                renderCartItems();
            });
        } else {
            client.createCart().then(function (newCart) {
                cart = newCart;
                localStorage.setItem('lastCartId', cart.id);
                cartLineItemCount = 0;
            });
        }

        var previousFocusItem;


        /* Fetch product and init
        ============================================================ */

        client.fetchProduct(productId).then(function (fetchedProduct) {
            console.log(fetchedProduct);
            product = fetchedProduct;
            var selectedVariant = product.selectedVariant;
            var selectedVariantImage = product.selectedVariantImage;
            var currentOptions = product.options;

            var variantSelectors = generateSelectors(product);
            $('.variant-selectors').html(variantSelectors);

            // updateProductTitle(product.title);
            // updateVariantImage(selectedVariantImage);
            updateVariantTitle(selectedVariant);
            updateVariantPrice(selectedVariant);
            attachOnVariantSelectListeners(product);
            updateCartTabButton();
            bindEventListeners();
        });

        /* Generate DOM elements for variant selectors
        ============================================================ */
        function generateSelectors(product) {
            var elements = product.options.map(function(option) {
                var optionsHtml = option.values.map(function(value, index) {
                    var isChecked = ( index === 0 ) ? 'checked="checked"' : '';
                    return '<p class="product-radio"><input type="radio" id="' + value + '" ' + isChecked + ' name="' + option.name + '" value="' + value + '"/><label for="' + value + '">' + value + '</label></p>';
                });
                return '<div class="shopify-select">' + optionsHtml.join('') + '</div>'
            });

            return elements;
        }


        /* Bind Event Listeners
        ============================================================ */
        function bindEventListeners() {
            /* cart close button listener */
            $('.cart .btn--close').on('click', closeCart);

            /* click away listener to close cart */
            $(document).on('click', function(evt) {
                if((!$(evt.target).closest('.cart').length) && (!$(evt.target).closest('.js-prevent-cart-listener').length)) {
                    closeCart();
                }
            });

            /* escape key handler */
            var ESCAPE_KEYCODE = 27;
            $(document).on('keydown', function (evt) {
                if (evt.which === ESCAPE_KEYCODE) {
                    if (previousFocusItem) {
                        $(previousFocusItem).focus();
                        previousFocusItem = ''
                    }
                    closeCart();
                }
            });

            /* checkout button click listener */
            $('.btn--cart-checkout').on('click', function () {
                window.open(cart.checkoutUrl, '_self');
            });

            /* buy button click listener */
            $('.button--add-to-cart').on('click', buyButtonClickHandler);

            /* increment quantity click listener */
            $('.cart').on('click', '.quantity-increment', function () {
                var variantId = $(this).data('variant-id');
                incrementQuantity(variantId);
            });

            /* decrement quantity click listener */
            $('.cart').on('click', '.quantity-decrement', function() {
                var variantId = $(this).data('variant-id');
                decrementQuantity(variantId);
            });

            /* update quantity field listener */
            $('.cart').on('keyup', '.cart-item__quantity', debounce(fieldQuantityHandler, 250));

            /* cart tab click listener */
            $('.btn--cart-tab').click(function() {
                setPreviousFocusItem(this);
                openCart();
            });
        }


        /* Variant option change handler
        ============================================================ */
        function attachOnVariantSelectListeners(product) {
            $('.variant-selectors').on('change', 'input', function(event) {
                var $element = $(event.target);
                var name = $element.attr('name');
                var value = $element.val();
                // $(this).attr('checked', 'checked');
                product.options.filter(function(option) {
                    return option.name === name;
                })[0].selected = value;

                var selectedVariant = product.selectedVariant;
                var selectedVariantImage = product.selectedVariantImage;
                // updateProductTitle(product.title);
                // updateVariantImage(selectedVariantImage);
                updateVariantTitle(selectedVariant);
                updateVariantPrice(selectedVariant);
            });
        }

        /* Update product title
        ============================================================ */
        function updateProductTitle(title) {
            $('.product-modal .product-title').text(title);
        }

        /* Update product image based on selected variant
        ============================================================ */
        function updateVariantImage(image) {
            var src = (image) ? image.src : ShopifyBuy.NO_IMAGE_URI;

            $('.product-modal .variant-image').attr('src', src);
        }

        /* Update product variant title based on selected variant
        ============================================================ */
        function updateVariantTitle(variant) {
            $('.product-modal .variant-title').text(variant.title);
        }

        /* Update product variant price based on selected variant
        ============================================================ */
        function updateVariantPrice(variant) {
            $('.product-modal .variant-price').text('$' + variant.price);
        }

        /* Attach and control listeners onto buy button
        ============================================================ */
        function buyButtonClickHandler(evt) {
            evt.preventDefault();
            var id = product.selectedVariant.id;
            var quantity;
            var quantity_val = $('#product-qty').val();
            var cartLineItem = findCartItemByVariantId(id);

            quantity = cartLineItem ? (parseInt(cartLineItem.quantity) + parseInt(quantity_val)) : parseInt(quantity_val);
            console.log( quantity );
            addOrUpdateVariant(product.selectedVariant, quantity);
            setPreviousFocusItem(evt.target);
            $('#checkout').focus();
        }

        $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.jsc_quantity input');
        $('.jsc_quantity').each(function() {
            var spinner = jQuery(this),
            input = spinner.find('input[type="number"]'),
            btnUp = spinner.find('.quantity-up'),
            btnDown = spinner.find('.quantity-down'),
            min = input.attr('min'),
            max = input.attr('max');

            spinner.on('click', '.quantity-up', function() {
                var oldValue = parseFloat(input.val());
                if (oldValue >= max) {
                    var newVal = oldValue;
                } else {
                    var newVal = oldValue + 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });

            spinner.on('click', '.quantity-down', function() {
                var oldValue = parseFloat(input.val());
                if (oldValue <= min) {
                    var newVal = oldValue;
                } else {
                    var newVal = oldValue - 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });

        });

        /* Update product variant quantity in cart
        ============================================================ */
        function updateQuantity(fn, variantId) {
            var variant = product.variants.filter(function (variant) {
                return (variant.id === variantId);
            })[0];
            var quantity;
            var cartLineItem = findCartItemByVariantId(variant.id);
            if (cartLineItem) {
                quantity = fn(cartLineItem.quantity);
                updateVariantInCart(cartLineItem, quantity);
            }
        }

        /* Decrease quantity amount by 1
        ============================================================ */
        function decrementQuantity(variantId) {
            updateQuantity(function(quantity) {
                return quantity - 1;
            }, variantId);
        }

        /* Increase quantity amount by 1
        ============================================================ */
        function incrementQuantity(variantId) {
            updateQuantity(function(quantity) {
                return quantity + 1;
            }, variantId);
        }

        /* Update product variant quantity in cart through input field
        ============================================================ */
        function fieldQuantityHandler(evt) {
            var variantId = parseInt($(this).closest('.cart-item').attr('data-variant-id'), 10);
            var variant = product.variants.filter(function (variant) {
                return (variant.id === variantId);
            })[0];
            var cartLineItem = findCartItemByVariantId(variant.id);
            var quantity = evt.target.value;
            if (cartLineItem) {
                console.log(quantity);
                updateVariantInCart(cartLineItem, quantity);
            }
        }

        /* Debounce taken from _.js
        ============================================================ */
        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            }
        }

        /* Open Cart
        ============================================================ */
        function openCart() {
            $('.cart').addClass('js-active');
        }

        /* Close Cart
        ============================================================ */
        function closeCart() {
            $('.cart').removeClass('js-active');
            $('.overlay').removeClass('js-active');
        }

        /* Find Cart Line Item By Variant Id
        ============================================================ */
        function findCartItemByVariantId(variantId) {
            return cart.lineItems.filter(function (item) {
                return (item.variant_id === variantId);
            })[0];
        }

        /* Determine action for variant adding/updating/removing
        ============================================================ */
        function addOrUpdateVariant(variant, quantity) {
            openCart();
            var cartLineItem = findCartItemByVariantId(variant.id);

            if (cartLineItem) {
                updateVariantInCart(cartLineItem, quantity);
            } else {
                addVariantToCart(variant, quantity);
            }

            updateCartTabButton();
        }

        /* Update details for item already in cart. Remove if necessary
        ============================================================ */
        function updateVariantInCart(cartLineItem, quantity) {
            var variantId = cartLineItem.variant_id;
            var cartLength = cart.lineItems.length;
            cart.updateLineItem(cartLineItem.id, quantity).then(function(updatedCart) {
                var $cartItem = $('.cart').find('.cart-item[data-variant-id="' + variantId + '"]');
                if (updatedCart.lineItems.length >= cartLength) {
                    $cartItem.find('.cart-item__quantity').val(cartLineItem.quantity);
                    $cartItem.find('.cart-item__price').text(formatAsMoney(cartLineItem.line_price));
                } else {
                    $cartItem.addClass('js-hidden').bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
                        $cartItem.remove();
                    });
                }

                updateCartTabButton();
                updateTotalCartPricing();
                if (updatedCart.lineItems.length < 1) {
                    closeCart();
                }
            }).catch(function (errors) {
                console.log('Fail');
                console.error(errors);
            });
        }

        /* Add 'quantity' amount of product 'variant' to cart
        ============================================================ */
        function addVariantToCart(variant, quantity) {
            openCart();

            cart.createLineItemsFromVariants({ variant: variant, quantity: quantity }).then(function() {
                var cartItem = cart.lineItems.filter(function (item) {
                    return (item.variant_id === variant.id);
                })[0];
                var $cartItem = renderCartItem(cartItem);
                var $cartItemContainer = $('.cart-item-container');
                $cartItemContainer.append($cartItem);
                setTimeout(function () {
                    $cartItemContainer.find('.js-hidden').removeClass('js-hidden');
                }, 0)

            }).catch(function (errors) {
                console.log('Fail');
                console.error(errors);
            });

            updateTotalCartPricing();
            updateCartTabButton();
        }

        /* Return required markup for single item rendering
        ============================================================ */
        function renderCartItem(lineItem) {
            var lineItemEmptyTemplate = $('#CartItemTemplate').html();
            var $lineItemTemplate = $(lineItemEmptyTemplate);
            // var itemImage = lineItem.image.src;
            $lineItemTemplate.attr('data-variant-id', lineItem.variant_id);
            $lineItemTemplate.addClass('js-hidden');
            // $lineItemTemplate.find('.cart-item__img').css('background-image', 'url(' + itemImage + ')');
            $lineItemTemplate.find('.cart-item__title').text(lineItem.title);
            $lineItemTemplate.find('.cart-item__variant-title').text(lineItem.variant_title);
            $lineItemTemplate.find('.cart-item__price').text(formatAsMoney(lineItem.line_price));
            $lineItemTemplate.find('.cart-item__quantity').attr('value', lineItem.quantity);
            $lineItemTemplate.find('.quantity-decrement').attr('data-variant-id', lineItem.variant_id);
            $lineItemTemplate.find('.quantity-increment').attr('data-variant-id', lineItem.variant_id);

            return $lineItemTemplate;
        }

        /* Render the line items currently in the cart
        ============================================================ */
        function renderCartItems() {
            var $cartItemContainer = $('.cart-item-container');
            $cartItemContainer.empty();
            var lineItemEmptyTemplate = $('#CartItemTemplate').html();
            var $cartLineItems = cart.lineItems.map(function (lineItem, index) {
                return renderCartItem(lineItem);
            });
            $cartItemContainer.append($cartLineItems);

            setTimeout(function () {
                $cartItemContainer.find('.js-hidden').removeClass('js-hidden');
            }, 0)
            updateTotalCartPricing();
        }

        /* Update Total Cart Pricing
        ============================================================ */
        function updateTotalCartPricing() {
            $('.cart .pricing').text(formatAsMoney(cart.subtotal));
        }

        /* Format amount as currency
        ============================================================ */
        function formatAsMoney(amount, currency, thousandSeparator, decimalSeparator, localeDecimalSeparator) {
            currency = currency || '$';
            thousandSeparator = thousandSeparator || ',';
            decimalSeparator = decimalSeparator || '.';
            localeDecimalSeparator = localeDecimalSeparator || '.';
            var regex = new RegExp('(\\d)(?=(\\d{3})+\\.)', 'g');

            return currency + parseFloat(amount, 10).toFixed(2)
            .replace(localeDecimalSeparator, decimalSeparator)
            .replace(regex, '$1' + thousandSeparator)
            .toString();
        }

        /* Update cart tab button
        ============================================================ */
        function updateCartTabButton() {
            if (cart.lineItems.length > 0) {
                $('.shopify-cart .shopify-cart__count').html(cart.lineItemCount+' <span class="hidden-xs-down">Items</span>');
                // $('.btn--cart-tab .btn__counter').html(cart.lineItemCount);
                // $('.btn--cart-tab').addClass('js-active');
            } else {
                $('.shopify-cart .shopify-cart__count').html('');
                // $('.btn--cart-tab').removeClass('js-active');
                // $('.cart').removeClass('js-active');
            }
        }

        /* Set previously focused item for escape handler
        ============================================================ */
        function setPreviousFocusItem(item) {
            previousFocusItem = item;
        }
    });

})(jQuery); // Fully reference jQuery after this point.
